import '../sass/person-profile.scss';

import { openModal } from '../../../../assets/src/js/common/modals';

(() => {
    const $templateParts = document.querySelectorAll('.person-profile');

    if (!$templateParts) return;

    $templateParts.forEach($templatePart => {
        const $searchDropdown = $templatePart.querySelector('.person-profile-search-dropdown__dropdown');
        const $links = $templatePart.querySelectorAll('.person-profile-nav__link');
        const $panels = $templatePart.querySelectorAll('.person-profile-panel');
        const $select = $templatePart.querySelector('.person-profile-statistics__select');
        const $statisticsTables = $templatePart.querySelectorAll('.person-profile-statistics__table');
        const $statisticsListItems = $templatePart.querySelectorAll('.person-profile-statistics__list-item');
        const $videoModal = $templatePart.querySelector('.person-profile-video-modal');
        const $videoPlayer = $templatePart.querySelector('.person-profile-video-modal__video-player');
        const $formTableBody = $templatePart.querySelector('.person-profile-form__table-body');
        const $formList = $templatePart.querySelector('.person-profile-form__list');
        const $winsTableBody = $templatePart.querySelector('.person-profile-wins__table-body');
        const $winsList = $templatePart.querySelector('.person-profile-wins__list');
        const $formLoadMore = $templatePart.querySelector('.person-profile-form__load-more');
        const $winsLoadMore = $templatePart.querySelector('.person-profile-wins__load-more');
        const $formYearSelect = $templatePart.querySelector('.person-profile-form__year-select');
        const $winsYearSelect = $templatePart.querySelector('.person-profile-wins__year-select');

        let fetchPersonWinsController, fetchPersonResultsController;

        const initSearchDropdown = () => {
            if (!$searchDropdown) return;

            new Details($searchDropdown);
        };

        const initLinks = () => {
            if (!$links || !$panels) return;

            $links.forEach($link => {
                $link.addEventListener('click', e => {
                    e.preventDefault();
                    
                    const { panel } = $link.dataset;

                    const $panels = document.querySelectorAll(`.person-profile-panel`);

                    $links.forEach($link => {
                        if ($link.dataset.panel === panel) {
                            $link.classList.add('btn--solid', 'btn--disabled');
                            $link.classList.remove('btn--outline');
                        } else {
                            $link.classList.remove('btn--solid', 'btn--disabled');
                            $link.classList.add('btn--outline');
                        }
                    });

                    $panels.forEach($panel => {
                        if ($panel.classList.contains(`person-profile-panel--${panel}`)) {
                            $panel.classList.add('person-profile-panel--show');
                        } else {
                            $panel.classList.remove('person-profile-panel--show');
                        }
                    });

                    history.replaceState(null, null, $link.href);
                });
            });
        };

        const initStatisticsSelect = () => {
            if (!$select) return;

            $select.addEventListener('change', e => {
                e.preventDefault();

                const { value } = e.target;

                $statisticsTables.forEach($table => {
                    if ($table.classList.contains(`person-profile-statistics__table--${value}`)) {
                        $table.classList.remove('person-profile-statistics__table--hide');
                    } else {
                        $table.classList.add('person-profile-statistics__table--hide');
                    }
                });

                $statisticsListItems.forEach($item => {
                    if ($item.classList.contains(`person-profile-statistics__list-item--${value}`)) {
                        $item.classList.remove('person-profile-statistics__list-item--hide');
                    } else {
                        $item.classList.add('person-profile-statistics__list-item--hide');
                    }
                })
            });
        };

        const initModals = () => {
            if (!$videoModal) return;

            const $videoModalBtns = $templatePart.querySelectorAll('.person-profile-video-modal-btn');

            if ($videoModalBtns) {
                $videoModalBtns.forEach($btn => {
                    if ($btn.classList.contains('person-profile-video-modal-btn--init')) return;

                    $btn.classList.add('person-profile-video-modal-btn--init');

                    const { vimeoVideoId } = $btn.dataset;

                    $btn.addEventListener('click', () => {
                        let videoPlayer;

                        if ($videoPlayer) {
                            $videoPlayer.innerHTML = `<iframe src="https://player.vimeo.com/video/${vimeoVideoId}?loop=false&byline=false&portrait=false&title=false&speed=true&transparent=0&gesture=media&controls=0" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`
                            videoPlayer = new Plyr($videoPlayer);
                            videoPlayer.play();
                        }

                        $videoModal.addEventListener('modalafterclose', () => {
                            videoPlayer?.stop();
                        });

                        openModal($videoModal);
                    });
                });
            }
        };

        const initLoadMore = () => {
            if ($formLoadMore) {
                $formLoadMore.addEventListener('submit', e => {
                    e.preventDefault();

                    fetchPersonResults({
                        $loadMoreEl: $formLoadMore,
                        $tableResultsEl: $formTableBody,
                        $listResultsEl: $formList,
                        wins: false,
                    });
                });
            }

            if ($winsLoadMore) {
                $winsLoadMore.addEventListener('submit', e => {
                    e.preventDefault();

                    fetchPersonResults({
                        $loadMoreEl: $winsLoadMore,
                        $tableResultsEl: $winsTableBody,
                        $listResultsEl: $winsList,
                        wins: true,
                    });
                });
            }
        };

        const fetchPersonResults = async ({
            $loadMoreEl,
            $tableResultsEl,
            $listResultsEl,
            wins = false,
            newResults = false,
        }) => {
            if (wins) {
                if (fetchPersonWinsController) {
                    fetchPersonWinsController.abort();
                }

                fetchPersonWinsController = new AbortController();
            } else {
                if (fetchPersonResultsController) {
                    fetchPersonResultsController.abort();
                }

                fetchPersonResultsController = new AbortController();
            }

            const $personId = $loadMoreEl?.querySelector('[name="person_id"]');
            const $personType = $loadMoreEl?.querySelector('[name="person_type"]');
            const $year = $loadMoreEl?.querySelector('[name="year"]');
            const $nonce = $loadMoreEl?.querySelector('[name="_wpnonce"]');
            const $formsPage = $loadMoreEl?.querySelector('[name="forms_page"]');
            const $winsPage = $loadMoreEl?.querySelector('[name="wins_page"]');

            if (newResults) {
                $tableResultsEl.classList.add('person-profile-form__table--loading');
                $listResultsEl.classList.add('person-profile-form__list--loading');

                if ($formsPage) {
                    $formsPage.value = 1;
                }

                if ($winsPage) {
                    $winsPage.value = 1;
                }
            }

            const fetchParams = new URLSearchParams();

            fetchParams.set('id', $personId?.value);
            fetchParams.set('type', $personType?.value);
            fetchParams.set('year', $year?.value);

            if ($formsPage) {
                fetchParams.set('page', $formsPage?.value);
            }

            if ($winsPage) {
                fetchParams.set('page', $winsPage?.value);
            }

            fetchParams.set('wins', wins ? 1 : 0);

            $loadMoreEl.classList.add('person-profile-load-more--loading');

            try {
                fetch('/wp-json/point-to-point/person-form-results?' + fetchParams.toString(), {
                    method: 'GET',
                    signal: wins ? fetchPersonWinsController.signal : fetchPersonResultsController.signal,
                    headers: {
                        'X-WP-Nonce' : $nonce?.value,
                    },
                }).then(async response => {
                    if (!response.ok) {
                        throw new Error(`Response status: ${response.status}`);
                    }

                    const json = await response.json();
                
                    return json;
                }).then(json => {
                    if ($listResultsEl) {
                        if (newResults) {
                            $listResultsEl.innerHTML = json?.list_html ?? '';
                        } else {
                            $listResultsEl.insertAdjacentHTML('beforeend', json?.list_html ?? '');
                        }
                    }
                    
                    if ($tableResultsEl) {
                        if (newResults) {
                            $tableResultsEl.innerHTML = json?.table_html ?? '';
                        } else {
                            $tableResultsEl.insertAdjacentHTML('beforeend', json?.table_html ?? '');
                        }
                    }

                    if (!json?.load_more) {
                        $loadMoreEl.classList.add('person-profile-load-more--hide');
                    } else {
                        $loadMoreEl.classList.remove('person-profile-load-more--hide');
                    }

                    const params = new URLSearchParams(document.location.search);

                    if ($formsPage?.value && !isNaN($formsPage?.value)) {
                        params.set('forms_page', parseInt($formsPage.value));

                        $formsPage.value = parseInt($formsPage.value) + 1;
                    } else {
                        params.delete('forms_page');
                    }

                    if ($winsPage?.value && !isNaN($winsPage?.value)) {
                        params.set('wins_page', parseInt($winsPage.value));

                        $winsPage.value = parseInt($winsPage.value) + 1;
                    } else {
                        params.delete('wins_page');
                    }

                    if ($year?.value && !isNaN($year?.value)) {
                        params.set('filter_year', parseInt($year.value));
                    } else {
                        params.delete('filter_year');
                    }

                    history.replaceState(null, null, '?' + params.toString());

                    initModals();

                    $loadMoreEl.classList.remove('person-profile-load-more--loading');
                    $tableResultsEl.classList.remove('person-profile-form__table--loading');
                    $listResultsEl.classList.remove('person-profile-form__list--loading');
                });
            } catch (error) {
                $loadMoreEl.classList.remove('person-profile-load-more--loading');
                $tableResultsEl.classList.remove('person-profile-form__table--loading');
                $listResultsEl.classList.remove('person-profile-form__list--loading');
            }
        };

        const initYearFilter = () => {
            if ($formYearSelect) {
                $formYearSelect.addEventListener('change', e => {
                    e.preventDefault();
                
                    if ($formLoadMore) {
                        const $formYearInput = $formLoadMore.querySelector('[name="year"]');

                        if ($formYearInput) {
                            $formYearInput.value = e.target.value;
                        }
                    }

                    fetchPersonResults({
                        $loadMoreEl: $formLoadMore,
                        $tableResultsEl: $formTableBody,
                        $listResultsEl: $formList,
                        wins: false,
                        newResults: true,
                    });
                });
            }

            if ($winsYearSelect && $winsLoadMore) {
                $winsYearSelect.addEventListener('change', e => {
                    const $winsYearInput = $winsLoadMore?.querySelector('[name="year"]');

                    if ($winsYearInput) {
                        $winsYearInput.value = e.target.value;
                    }

                    fetchPersonResults({
                        $loadMoreEl: $winsLoadMore,
                        $tableResultsEl: $winsTableBody,
                        $listResultsEl: $winsList,
                        wins: true,
                        newResults: true,
                    });
                });
            }
        };

        initSearchDropdown();
        initLinks();
        initStatisticsSelect();
        initModals();
        initLoadMore();
        initYearFilter();
    });
})();
